export enum LobbyFilterSpeed {
    Any = -1, // local only
    Normal = 1,
    Fast = 2
}

